/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useLayoutEffect, useRef } from "react";

// Keeps a wrapper at its last measured height while isHolding is true.
export const useHeldHeight = (isHolding) => {
  const ref = useRef(null);
  const heightRef = useRef(0);

  useLayoutEffect(() => {
    if (!isHolding && ref.current) {
      heightRef.current = ref.current.offsetHeight;
    }
  });

  return { ref, style: isHolding ? { minHeight: heightRef.current } : undefined };
};
